import DocumentHead from '@/components/document-head/DocumentHead'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import DumpEditorForm from '@/routes/dumps/DumpEditor.form'
import { dumpEditorRouteLoader } from '@/routes/dumps/DumpEditor.route'
import { DumpEditorProps } from '@/routes/dumps/DumpEditor.types'
import { isUserRoleAllowed } from '@/routes/utils'

import { Suspense } from 'react'
import { useFetcher, useParams } from 'react-router-dom'
import { Await, useLoaderData } from 'react-router-typesafe'

const DumpEditor = (props: DumpEditorProps) => {
  const { creating } = props

  const { title, dump, getStati, getTipologie, getUserInfo, defaultCRUDAllowedRoles } =
    useLoaderData<typeof dumpEditorRouteLoader>()

  const { clientId } = useParams()
  const fetcher = useFetcher()
  return (
    <>
      <Suspense fallback={<LoadingPanel />}>
        <Await resolve={Promise.all([getStati, getTipologie, getUserInfo])}>
          {([stati, tipologie, userInfo]) => (
            <>
              <h2 className={clientId ? '' : 'content-block'}>{title}</h2>
              <div
                id="editor-hour-container"
                className={clientId ? 'dx-card responsive-paddings' : 'content-block dx-card responsive-paddings'}
              >
                <fetcher.Form>
                  <DumpEditorForm
                    dump={dump.data}
                    stati={stati.data.value}
                    tipologie={tipologie.data.value}
                    isRoleAllowed={isUserRoleAllowed(userInfo?.roles, defaultCRUDAllowedRoles)}
                    creating={creating}
                    fetcher={fetcher}
                  ></DumpEditorForm>
                </fetcher.Form>
              </div>
            </>
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default DumpEditor
